import { GenIcon } from '../helpers/IconBase.es.js';

const HomeLocationBlueColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_1338_1335)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M20 8.10314V15.8331C19.9987 16.9378 19.5593 17.9968 18.7782 18.778C17.997 19.5591 16.938 19.9985 15.8333 19.9998H15C14.779 19.9998 14.567 19.912 14.4107 19.7557C14.2545 19.5994 14.1667 19.3875 14.1667 19.1665C14.1667 18.9455 14.2545 18.7335 14.4107 18.5772C14.567 18.4209 14.779 18.3331 15 18.3331H15.8333C16.4964 18.3331 17.1323 18.0697 17.6011 17.6009C18.0699 17.1321 18.3333 16.4962 18.3333 15.8331V8.10314C18.3334 7.6939 18.2329 7.29092 18.0408 6.92957C17.8488 6.56821 17.5709 6.25954 17.2317 6.03064L11.3983 2.0948C10.9861 1.81381 10.4989 1.66352 10 1.66352C9.50115 1.66352 9.01386 1.81381 8.60167 2.0948L2.76834 6.03064C2.4291 6.25954 2.15125 6.56821 1.95917 6.92957C1.76709 7.29092 1.66665 7.6939 1.66667 8.10314V15.8331C1.66667 16.4962 1.93006 17.1321 2.3989 17.6009C2.86774 18.0697 3.50363 18.3331 4.16667 18.3331H5C5.22102 18.3331 5.43298 18.4209 5.58926 18.5772C5.74554 18.7335 5.83334 18.9455 5.83334 19.1665C5.83334 19.3875 5.74554 19.5994 5.58926 19.7557C5.43298 19.912 5.22102 19.9998 5 19.9998H4.16667C3.06201 19.9985 2.00297 19.5591 1.22185 18.778C0.440738 17.9968 0.00132648 16.9378 3.26423e-06 15.8331V8.10314C-0.000850798 7.42124 0.165902 6.74958 0.48559 6.14726C0.805278 5.54493 1.2681 5.03042 1.83334 4.64897L7.66667 0.712304C8.35439 0.245599 9.16638 -0.00390625 9.9975 -0.00390625C10.8286 -0.00390625 11.6406 0.245599 12.3283 0.712304L18.1617 4.64897C18.7275 5.03022 19.191 5.54457 19.5115 6.14684C19.8321 6.74911 19.9998 7.42088 20 8.10314Z",
              fill: "#0200BC"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M15.3927 14.7388C15.6859 14.0309 15.8358 13.2719 15.8337 12.5056C15.8337 11.5459 15.597 10.601 15.1445 9.7547C14.692 8.90838 14.0377 8.18678 13.2395 7.65387C12.4414 7.12096 11.5241 6.7932 10.5689 6.69966C9.61381 6.60611 8.65035 6.74966 7.76398 7.11758C6.87761 7.48551 6.0957 8.06644 5.48758 8.80888C4.87946 9.55131 4.46391 10.4323 4.27777 11.3738C4.09163 12.3153 4.14065 13.2881 4.42048 14.2061C4.70032 15.1241 5.20232 15.9589 5.88199 16.6364L8.80449 19.4948C9.12516 19.8052 9.55399 19.9788 10.0003 19.9788C10.4467 19.9788 10.8755 19.8052 11.1962 19.4948L14.1253 16.6298C14.6687 16.0895 15.0994 15.4468 15.3927 14.7388ZM14.167 12.5056C14.167 11.8204 13.998 11.1458 13.6751 10.5415C13.3521 9.93721 12.8851 9.4219 12.3154 9.0412C11.7457 8.6605 11.0909 8.42618 10.409 8.35898C9.72708 8.29178 9.03915 8.39378 8.40609 8.65594C7.77304 8.91811 7.21441 9.33235 6.77968 9.86197C6.34495 10.3916 6.04755 11.0202 5.9138 11.6923C5.78006 12.3643 5.81411 13.0589 6.01293 13.7146C6.21176 14.3703 6.56922 14.9669 7.05366 15.4514L9.97033 18.3031L12.9537 15.4448C13.34 15.0593 13.6461 14.6011 13.8544 14.0966C14.0627 13.5921 14.1689 13.0514 14.167 12.5056Z",
              fill: "#00973C"
            }
          },
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M12.079 13.8887C12.3537 13.4776 12.5003 12.9942 12.5003 12.4998C12.5003 11.8367 12.2369 11.2009 11.7681 10.732C11.2993 10.2632 10.6634 9.99978 10.0003 9.99978C9.50587 9.99978 9.02252 10.1464 8.6114 10.4211C8.20028 10.6958 7.87985 11.0863 7.69063 11.5431C7.50141 11.9999 7.4519 12.5026 7.54836 12.9875C7.64483 13.4725 7.88293 13.9179 8.23256 14.2675C8.58219 14.6172 9.02765 14.8553 9.5126 14.9517C9.99755 15.0482 10.5002 14.9987 10.957 14.8095C11.4139 14.6203 11.8043 14.2998 12.079 13.8887Z",
              fill: "#00973C"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_1338_1335" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { HomeLocationBlueColored };
